import { ACLMap, aclPrivesToString, DirentNameEnum, permissionMap2Acl } from '@orgbrain/lib-data';
import { DirentNode, TreeNode } from './lib/classes';

const BRIEF_LEN = 10;
const BRIEF_PRE = '__';
const display: { [key in DirentNameEnum]: string } = {
  [DirentNameEnum.VINILLA]: '',
  [DirentNameEnum.USER_ID]: 'User',
  [DirentNameEnum.MEETING_ID]: 'Meeting',
  [DirentNameEnum.ORGANIZATION_ID]: 'Organization',
  [DirentNameEnum.KEY]: '',
  [DirentNameEnum.KEY_MUTABLE]: '',
};

export const direntPermDisplayHelper = {
  permissions(dirent: DirentNode, idToName?: { [key: string]: string }) {
    const acl = dirent.acl;
    const ecl = dirent.ecl;
    const scl = dirent.scl;

    let rets = [];
    if (acl) {
      rets.push('ACL: ' + this.toGroupPERMSbrief(acl, idToName));
    }

    if (ecl) {
      rets.push('ECL: ' + this.toGroupPERMSbrief(ecl, idToName));
    }

    if (scl) {
      rets.push('SCL: ' + this.toGroupPERMSbrief(scl, idToName));
    }

    if (dirent.direntPermissionsMap) {
      const xcl = permissionMap2Acl({ permissionMap: dirent.direntPermissionsMap });
      rets.push('PERM: ' + this.toGroupPERMSbrief(xcl, idToName));
    }
    return rets.join(' ; ');
  },

  permissionsBrief(dirent: DirentNode, idToName?: { [key: string]: string }) {
    const acl = dirent.acl;
    const ecl = dirent.ecl;
    const scl = dirent.scl;

    let rets = [];
    if (acl) {
      rets.push('ACL: ' + this.toGroupPERMSbrief(acl, idToName));
    }

    if (ecl) {
      rets.push('ECL: ' + this.toGroupPERMSbrief(ecl, idToName));
    }

    if (scl) {
      rets.push('SCL: ' + this.toGroupPERMSbrief(scl, idToName));
    }

    return rets.join(' ; ');
  },

  id2Name(key, idToName?: { [key: string]: string }) {
    let grpName = (idToName && idToName[key]) || key;
    return grpName;
  },

  toGroupPERMSbrief(acl: ACLMap, idToName?: { [key: string]: string }) {
    let rets = [];
    for (let key in acl) {
      let grpName = idToName && idToName[key];
      let subKey;
      if (!grpName) {
        subKey = key.substring(25);
        if (subKey.length > BRIEF_LEN) {
          subKey = BRIEF_PRE + subKey.substring(subKey.length - BRIEF_LEN);
        }
      } else {
        subKey = grpName;
      }

      rets.push(`${subKey}:${aclPrivesToString(acl[key])}`);
    }
    return rets.join(' ,');
  },

  handleOf(node: TreeNode, idToName?: { [key: string]: string }) {
    if (!node || !node.dirent) {
      return 'Ooops - no dirent  found';
    }

    return `
    ${display[node.dirent.nameType]} ${direntPermDisplayHelper.id2Name(
      node.dirent.name,
      idToName
    )} (${Object.keys(node.children || {}).length})`;
  },

  handleOfDirent(dirent: DirentNode) {
    let name = dirent.name;

    return `${display[dirent.nameType]} ${name}`;
  },

  handleOfDirentBrief(dirent: DirentNode) {
    let name = dirent.name;
    if (dirent.name.length > BRIEF_LEN) {
      name = BRIEF_PRE + dirent.name.substring(dirent.name.length - BRIEF_LEN);
    }

    return `${display[dirent.nameType]} ${name}`;
  },
};
